  // Read More Toggle
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".read-more-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      let text = this.previousElementSibling;

      if (text.classList.contains("expanded")) {
        text.classList.remove("expanded");
        this.innerText = "Read More";
      } else {
        text.classList.add("expanded");
        this.innerText = "Read Less";
      }
    });
  });
});


// mobile Toggle category link not open issue

document.addEventListener('DOMContentLoaded', () => {

  /* ==============================
     HYPER THEME – MOBILE MENU FIX
     ============================== */

  /* ---------- PARENT CATEGORY ---------- */
  document.querySelectorAll(
    'details[is="menu-drawer-details"] > summary'
  ).forEach(summary => {

    const details = summary.closest('details');
    const url = details.dataset.url;

    summary.addEventListener('click', e => {

      // Arrow / icon click → expand only
      if (e.target.closest('svg')) return;

      if (url) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      }
    });
  });

  /* ---------- SUB CATEGORY (WITH CHILDREN) ---------- */
  document.querySelectorAll(
    'details.accordion-details > summary'
  ).forEach(summary => {

    const details = summary.closest('details');
    const url = details.dataset.url;

    summary.addEventListener('click', e => {

      // Plus icon click → accordion toggle
      if (e.target.closest('svg')) return;

      if (url) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = url;
      }
    });
  });

  /* ---------- SIMPLE LINKS (NO CHILDREN) ---------- */
  document.querySelectorAll(
    '.menu-drawer a[href]'
  ).forEach(link => {
    link.addEventListener('click', e => {
      e.stopPropagation();
      window.location.href = link.href;
    });
  });

});



